// Tooltips
(function () {
    const tooltipButtons = document.querySelectorAll(`.js-tooltip-button`);

    tooltipButtons.forEach((button) => {
        const tooltipId = button.dataset.tooltipId;

        if (tooltipId) {
            const tooltipModal = document.querySelector(`#${tooltipId}`);

            if (tooltipModal) {
                const tooltipModalCloseButton = tooltipModal.querySelector(`.tooltip-modal__close-button`);
                const tooltip = tippy(button, {
                    content: tooltipModal,
                    interactive: true,
                    arrow: false,
                    appendTo: document.body,
                });

                tooltipModalCloseButton?.addEventListener(`click`, (evt) => {
                    evt.preventDefault();
                    tooltip.hide();
                });
            }
        }
    });
})();